// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Button,
  ThemeProvider,
} from "@mui/material";
// components
import Page from "../../../../../Components/Dashboard/Page";
import CardTotalSkills from "../../../../../sections/@dashboard/app/CardTotalSkills";
import CardSubSkills from "../../../../../sections/@dashboard/app/CardSubSkills";
import CardTotalPartners from "../../../../../sections/@dashboard/app/CardTotalPartners";
import CardTotalTrainers from "../../../../../sections/@dashboard/app/CardTotalTrainers";
import Iconify from "../../../../../Components/Dashboard/Iconify";
import Charts from "../../../../../Components/Dashboard/Charts";
import BasicTable from "../../../../../Components/Dashboard/Table";
import { Link as RouterLink } from "react-router-dom";
import CMTable from "../../../../../Components/Dashboard/CMTable";
import CardSearch from "../../../../../Components/Dashboard/CardSearch";
import Searchbox from "../../../../../Components/Dashboard/Searchbox";
import { poppinsCustomTheme } from "../../../../../Styles/GlobalStyles/PoppinsTheme";
import { Greeting } from "../../../../../Utils/greeting";
import Noactivity from "../../../../../Assets/Dashboard/NoActivity/noactivity.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllLoanBeneficiariesLs,
  fetchAllUserActivity,
} from "../../../../../Actions";
import CustomizedTimeline from "../../../../../Components/Dashboard/CustomizedTimeline";
const getActivityState = (state) => state.activityReducer;
// ----------------------------------------------------------------------
export default function Dashboard() {
  const dispatch = useDispatch();
  const { userActivity } = useSelector(getActivityState);
  const userid = JSON.parse(localStorage.getItem("user"))?.id || 0;
  const [tablePaginationData, setTablePaginationData] = useState({
    pageSize: 3,
    totalCount: 0,
    pageNumber: 1,
    Search: "",
  });

  const handleSearchChange = (event) => {
    const newSearchText = event.target.value;
    // setSearchText(newSearchText);
    setTablePaginationData({
      ...tablePaginationData,
      Search: newSearchText,
    });
  };

  useEffect(() => {
    dispatch(fetchAllUserActivity(userid));
    dispatch(fetchAllLoanBeneficiariesLs(tablePaginationData));
  }, [dispatch, userid, tablePaginationData]);

  console.log(userActivity[0], "uSER Activity");
  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Page title="SAED | Home">
        <Container maxWidth="xl">
          <Box sx={{ pb: 2 }}>
            <Typography
              variant="h5"
              style={{ fontWeight: 600, color: "#212B36" }}
            >
              <Greeting />
            </Typography>
          </Box>
          <Box sx={{ pb: 2 }}>
            <Paper
              sx={{
                p: 2.5,
                boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                borderRadius: "20px",
              }}
            >
              <Box sx={{ pb: 2 }}>
                <Card elevation={0}>
                  <CardHeader
                    sx={{ fontSize: "1px" }}
                    titleTypographyProps={{
                      variant: "body1",
                      color: "#05004E",
                      fontWeight: 600,
                    }}
                    subheaderTypographyProps={{
                      fontSize: 12,
                    }}
                    title="Overview"
                    subheader="Summary"
                  />
                </Card>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md>
                  <CardTotalSkills />
                </Grid>
                <Grid item xs={12} sm={6} md>
                  <CardSubSkills />
                </Grid>
                <Grid item xs={12} sm={6} md>
                  <CardTotalPartners />
                </Grid>
                <Grid item xs={12} sm={6} md>
                  <CardTotalTrainers />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                    borderRadius: "20px",
                  }}
                >
                  <Card elevation={0} sx={{ padding: "0px !important" }}>
                    <CardHeader
                      sx={{ fontSize: "1px" }}
                      titleTypographyProps={{
                        variant: "body1",
                        color: "#05004E",
                        fontWeight: 600,
                      }}
                      title=" Post Camp SAED Engagement"
                      action={<CardSearch />}
                    />
                    <CardContent>
                      <Charts />
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                    borderRadius: "20px",
                  }}
                >
                  <Card elevation={0} sx={{ padding: "0px !important" }}>
                    <CardHeader
                      sx={{ fontSize: "1px" }}
                      titleTypographyProps={{
                        variant: "body1",
                        color: "#05004E",
                        fontWeight: 600,
                      }}
                      title=" In Camp SAED Engagement"
                      action={<CardSearch />}
                    />
                    <CardContent>
                      <Charts />
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                    borderRadius: "20px",
                    height: "350px",
                  }}
                >
                  <Card
                    elevation={0}
                    sx={{
                      padding: "0px !important",
                      height: "100%",
                      overflowY: "hidden",
                      "&:hover": {
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                          width: 5,
                          height: 5,
                        },
                        "&::-webkit-scrollbar-track": {
                          backgroundColor: "#fff",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#DCDCDC",
                          borderRadius: 2,
                        },
                      },
                    }}
                  >
                    <CardHeader
                      sx={{ fontSize: "1px" }}
                      titleTypographyProps={{
                        variant: "body1",
                        color: "#05004E",
                        fontWeight: 600,
                      }}
                      title="Skill Acquisition Centre"
                      action={
                        <Button
                          to="#"
                          component={RouterLink}
                          size="small"
                          disableElevation
                          variant="contained"
                          sx={{
                            background: "#016c34",
                            textTransform: "capitalize",
                            fontSize: "12px",
                          }}
                        >
                          View
                        </Button>
                      }
                    />
                    <CardContent sx={{ padding: "0px !important" }}>
                      <BasicTable />
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                    borderRadius: "20px",
                    height: "350px",
                  }}
                >
                  <Card
                    elevation={0}
                    sx={{
                      padding: "0px !important",
                      paddingBottom: "10px",
                      height: "100%",
                    }}
                  >
                    <CardHeader
                      sx={{ fontSize: "1px" }}
                      titleTypographyProps={{
                        variant: "body1",
                        color: "#05004E",
                        fontWeight: 600,
                      }}
                      title="Track CM Progress"
                      action={
                        <Box display={"flex"} fontSize={"12px"}>
                          <Searchbox
                            width="10ch"
                            hoverwidth="15ch"
                            onChange={handleSearchChange}
                            value={tablePaginationData.Search}
                          />
                          <Button
                            to="/home/loanmanagement/loanstatus"
                            component={RouterLink}
                            size="small"
                            disableElevation
                            variant="contained"
                            sx={{
                              ml: 2,
                              background: "#016c34",
                              textTransform: "capitalize",
                              fontSize: "12px",
                            }}
                          >
                            View
                          </Button>
                        </Box>
                      }
                    />
                    <CardContent sx={{ padding: "0px !important" }}>
                      <CMTable />
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box>
                {userActivity[0] === null ? (
                  <Paper
                    sx={{
                      boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                      borderRadius: "20px",
                      height: "350px",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      textAlign: "center",
                    }}
                  >
                    <div>
                      <img
                        src={Noactivity}
                        alt="No activity"
                        width="250px"
                        height="250px"
                      />
                      <Typography>No Activity</Typography>
                    </div>
                  </Paper>
                ) : (
                  <Paper
                    sx={{
                      boxShadow: " 0px 4px 20px rgba(238, 238, 238, 0.501967)",
                      borderRadius: "20px",
                      height: "fit-content",
                      padding: "30px",
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        Recent Activity
                      </Typography>
                      <CustomizedTimeline />
                    </div>
                  </Paper>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </ThemeProvider>
  );
}
